// Helper function to send emails
import axios from 'axios';

export const sendEmail = async (recipient, cc, message) => {
    const emailPayload = {
        api_key: "api-15F4A72559DD4BA9A55944CC2492D0DB",
        sender: "haiti.undp.management.system@undp.org",
        to: [recipient],
        cc: [cc],
        subject: "Registration Confirmation",
        html_body: message,
        text_body: message
    };

    try {
        const response = await axios.post("https://api.smtp2go.com/v3/email/send", emailPayload);
        console.log('Email sent successfully:', response.data);
    } catch (error) {
        console.error('Error sending email:', error);
    }
};
